<template>
    <div>
        <ob1-cards class="full-height bg-white shadow-none" :with-composite-link="false" @ob1-cards-click.stop>
            <!--/* Titre*/-->
            <a
                :href="mobile.detailLink"
                class="tile no-decoration"
                :data-pdb-zid="dataPdbZid + index"
                :data-pdb-sc="'adv'"
                :data-pdb-idc="mobile.ean.value"
                :data-pdb-vi="dataPdbVi"
                :data-pdb-ta="mobile.advTracker"
                data-oevent-category="zone_recommandee_advise"
                :data-oevent-action="'bloc_' + index"
                :data-oevent-label="tagLabel(mobile.name)"
            >
                <div v-if="mobile.tag">
                    <strong class="ob1-tag ob1-tag-primary tag-margin">{{ mobile.tag }}</strong>
                </div>
                <div v-else class="pt-2" />
                <div class="px-1">
                    <div class="device-name">
                        <div class="text-center">{{ mobile.brand }}</div>
                        <p class="text-center mb-0 mx-1 fw-bold device-name-wrapper">{{ mobile.name }}</p>
                    </div>

                    <div
                        v-if="mobile.ean && mobile.reviewsStats"
                        class="bazaar-voice mb-1"
                    >
                        <ob1-rating
                            class="justify-content-center"
                            :average="mobile.reviewsStats.average"
                            :rating-results-height="1.375"
                        />
                    </div>
                    <div v-else class="spacer-25 mb-1" />

                    <div class="img-mobile text-center">
                        <!--/* Image */-->
                        <div class="img-reco-mobile-container">
                            <ob1-picture
                                v-if="mobile.image"
                                :visual="mobile.image"
                            />
                            <ob1-simple-image
                                v-if="mobile.imageOverlay"
                                :visual="mobile.imageOverlay"
                                class="img-reco-mobile-overlay"
                                :css-classes="'img-network-compatibility'"
                            />
                        </div>
                        <div class="infos-price">
                            <!--/* Prix */-->
                            <div v-if="mobile.price" class="text-center">
                                <ob1-prix-terminal
                                    class="ob1-price-compact"
                                    :multiple-price="mobile.price.price.multiplePrice"
                                    :total-price-with-promo="mobile.price.price.totalPriceWithPromo"
                                    :total-price-without-promo="mobile.price.price.totalPriceWithoutPromo"
                                    :order-price-label="mobile.price.price.orderPriceLabel"
                                    :is-cents-format="true"
                                />
                                <cb4x-pxf-mention
                                    v-if="mobile.price.price.paymentInfoLabel"
                                    :payment-info-label="mobile.price.price.paymentInfoLabel.label"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <!--/* Promo + odr + bonus reprise */-->
                <div class="info-advantage" :class="showAdvantageBloc ? 'bg-greige' : ''">
                    <div v-if="showAdvantageBloc">
                        <advantage-bloc
                            :advantage-messages="advantageMessages"
                            :bonus-recovery="mobile.price.advantageValues.bonusRecovery"
                            :discount="mobile.price.advantageValues.discount"
                            :odr="mobile.price.advantageValues.odr"
                        />
                    </div>
                </div>
            </a>
        </ob1-cards>
        <div class="d-flex">
            <!--/* Das */-->
            <das-tooltip
                v-if="mobile.dasAccessible"
                :id="'tooltip-reco-' + index"
                :das="mobile.dasAccessible"
                class="me-auto"
            />
            <!--Lien Detail du financement-->
            <FundingDetailsLink
                v-if="mobile.price.price.hasInstallmentPlan"
                :version-seo-id="mobile.seoId.value"
                :text="fundingDetailsDto.linkText"
                @fundingDetailsClick="handleFundingDetailsClick"
            />
        </div>
    </div>
</template>

<script>

import AdvantageBloc from "../../fragments/AdvantageBloc.vue";
import Cb4xPxfMention from "../../../../common/fragments/mobile/Cb4xPxfMention.vue";
import FundingDetailsLink from "./FundingDetailsLink.vue";
import DasTooltip from "../../DasTooltip.vue";

export default {
    components: {
        DasTooltip,
        FundingDetailsLink, Cb4xPxfMention, AdvantageBloc},
    props: {
        mobile: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            required: true
        },
        //Pour le tracking des balises métadonnées
        dataPdbZid: {
            type: String,
            required: true
        },
        advantageMessages: {
            type: Object,
            required: true
        },
        fundingDetailsDto: {
            type: Object,
            required: true
        }
    },
    computed: {
        showAdvantageBloc() {
            return this.mobile.price && this.mobile.price.advantageValues && (this.mobile.price.advantageValues.discount !== null
                    || this.mobile.price.advantageValues.odr !== null || this.mobile.price.advantageValues.bonusRecovery !== null);
        },
        dataPdbVi() {
            return this.mobile.image !== null ? this.mobile.image.src : ""
        }
    },
    methods: {
        tagLabel(label) {
            return stripAccents(label).split(' ').join('_')
        },
        handleFundingDetailsClick(versionSeoId) {
            this.$emit('fundingDetailsClick', versionSeoId);
        }
    }
}
</script>
<style scoped lang="scss">
@import 'ob1_common', 'ob1_variables';

.img-reco-mobile-container {
    position: relative;
    display: inline-block;
    height: px-to-rem(170);
    width: px-to-rem(170);
    text-align: center;
    bottom: px-to-rem(14);
}

.img-reco-mobile-overlay {
    position: absolute;
    right: px-to-rem(-20);
    bottom: px-to-rem(-10);
}

.tag-margin {
    margin-bottom: px-to-rem(4);
}

</style>
